import React from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { ToastContainer, toast } from "react-toastify";

import Header from "components/layout/Header";
import Login from "components/auth/Login";
import LoginCustomer from "components/auth/Login-customer";
import AppRouter from "components/AppRouter";

import Dashboard from "components/routers/dashboard-router";
import Profile from "components/routers/profile-router";
import LocationsRouter from "components/routers/locations-router";
import SystemListRouter from "components/routers/system-list-router";
import ConsumerGroupsRouter from "components/routers/consumer-groups-router";
import StoresRouter from "components/routers/stores-router";
import RetailersRouter from "components/routers/retailers-router";
import JobTraitsRouter from "components/routers/job-traits-router";
import JobMaintenanceRouter from "components/routers/job-maintenance-router";
import ProductMaintenanceRouter from "components/routers/product-maintenance-router";
import StoreTraitsRouter from "components/routers/store-traits-router";
import ServiceTypesRouter from "components/routers/service-types-router";
import SuppliersRouter from "components/routers/suppliers-router";
import ScheduleListRouter from "components/routers/schedule-router";
import SchedulingRouter from "components/routers/scheduling-router";
import Order from "components/routers/orders-router";
import OrderEntry from "components/routers/order-entry-router";
import LogsRouter from "components/routers/logs-router";
import CompanyInfoRouter from "components/routers/company-info-router";
import SummaryRouter from "components/routers/summary-router";
import MiscChargesRouter from "components/routers/misc-charges-router";
import InvoicingRouter from "components/routers/invoicing-router";
import EmailBlasterRouter from "components/routers/email-blaster-router";
import ReportBuilderRouter from "components/routers/report-builder-router";
import QuestionLibraryRouter from "components/routers/question-library-router";
import PlanogramMaintenanceRouter from "components/routers/planogram-maintenance-router";
import WorkersMaintenanceRouter from "components/routers/workers-maintenance-router";
import FileManagerRouter from "components/routers/file-manager-router";
import OrderExportLayoutsRouter from "components/routers/order-export-layouts-router";
import HrRouter from "components/routers/hr-router";
import Orders from "components/routers/export-orders-router";

import NotFound from "components/Extra/NotFound";
import PermissionError from "components/Extra/PermissionError";
import Privacy from "components/Extra/Privacy";
import ModalContainer from "components/custom/modals/index";
import UserTypes from "components/auth/user-types";
import MapSchedulingRouter from "./components/routers/map-scheduling-router";

const RestrictedRoute = ({
                             component: Component,
                             isAuthenticated,
                             ...rest
                         }) => (
    <Route
        {...rest}
        render={props =>
            (isAuthenticated ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: "/",
                        state: {
                            from: props.location
                        }
                    }}
                />
            ))
        }
    />
);

const PublicRoutes = ({
                        history,
                        isAuthenticated,
                        role
}) => {
    let RedirectToDashboard = <Redirect to="/dashboard"/>;
    if (role) {
        // if (role.includes(UserTypes.merchandiser)) {
        //     RedirectToDashboard = <Redirect to="/profile"/>;
        // }
        if (role.includes(UserTypes.merchandiser) && !role.includes(UserTypes.supervisor)) {
            RedirectToDashboard = <Redirect to="/dashboard"/>;
        } else if (role.includes(UserTypes.customer)) {
            RedirectToDashboard = <Redirect to="/summary"/>;
        }
    }

    return (
        <ConnectedRouter history={history}>
            <div>
                <Header/>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={() => (isAuthenticated ? RedirectToDashboard : <Login/>)}
                    />
                    <Route
                        exact
                        path="/loginCustomer"
                        render={() => (isAuthenticated ? RedirectToDashboard : <LoginCustomer/>)}
                    />

                    <RestrictedRoute
                        path="/dashboard"
                        component={Dashboard}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/profile"
                        component={Profile}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/schedule"
                        component={AppRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/logs"
                        component={LogsRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/schedules/maintenance"
                        component={SchedulingRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/schedules/mapMaintenance"
                        component={MapSchedulingRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/schedules/active"
                        component={ScheduleListRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/order"
                        component={Order}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/hr"
                        component={HrRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/orders"
                        component={Orders}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/orderEntry"
                        component={OrderEntry}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/locations"
                        component={LocationsRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/systemList"
                        component={SystemListRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/consumerGroups"
                        component={ConsumerGroupsRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/stores"
                        component={StoresRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/retailers"
                        component={RetailersRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/StoreTraits"
                        component={StoreTraitsRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/JobMaintenance"
                        component={JobMaintenanceRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/JobTraits"
                        component={JobTraitsRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/ProductMaintenance"
                        component={ProductMaintenanceRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/ServiceTypes"
                        component={ServiceTypesRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/suppliers"
                        component={SuppliersRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/companyInfo"
                        component={CompanyInfoRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/summary"
                        component={SummaryRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/miscCharges"
                        component={MiscChargesRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/invoicing"
                        component={InvoicingRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/emailBlaster"
                        component={EmailBlasterRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/reportBuilder"
                        component={ReportBuilderRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/questionLibrary"
                        component={QuestionLibraryRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/planogramMaintenance"
                        component={PlanogramMaintenanceRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/workers"
                        component={WorkersMaintenanceRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/fileManager"
                        component={FileManagerRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    <RestrictedRoute
                        path="/order-export-layouts"
                        component={OrderExportLayoutsRouter}
                        isAuthenticated={isAuthenticated}
                    />

                    {/* <Redirect to='/not-found'/> */}
                    <Route exact path="/permission-error" component={PermissionError}/>
                    <Route exact path="/privacy" component={Privacy}/>
                    <Route component={NotFound}/>
                </Switch>

                <ModalContainer/>
                <ToastContainer
                    closeOnClick={false}
                    autoClose={3000}
                    position="top-center"
                    type={toast.TYPE.INFO}
                />
            </div>
        </ConnectedRouter>
    );
};

PublicRoutes.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    role: PropTypes.any
};

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    role: state.auth.user.role
});

export default connect(mapStateToProps)(PublicRoutes);
